<template>
	<div class="gb-photoalbum-header-album-list">
		<div class="primary gb-photoalbum-header-album-layout">
			<div class="schedule_info">
				<div class="name">{{name}}</div>
				<div class="schedule-title">{{title}}<br></div>
				<div class="term">{{schedulePeriod()}}</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'GBPhotoAlbumListAlbumHeader',
	props: [
		"name",
		"begin",
		"end",
		"title",
	],
	data() {
		return {
		};
	},
	methods: {
		schedulePeriod: function() {
			if(this.begin !== null && this.end !== null) {
				let b = String(this.begin).substr(0, 4) + '年' + String(this.begin).substr(4, 2) + '月' + String(this.begin).substr(6, 2); + '日'
				let e = String(this.end).substr(0, 4) + '年' + String(this.end).substr(4, 2) + '月' + String(this.end).substr(6, 2) + '日';
				return b + '～' + e;
			}
			
			return null;
		}
	},
}
</script>
<style>
	.gb-photoalbum-header-album-list {
		flex: 0 0 300px !important;
		position: relative;
		border:solid 1px #DFDFDF;
		height: 59px;
		width: 300px;
		border-left: none;
	}
	.gb-photoalbum-header-album-list .schedule_info {
		padding: 4px 8px 4px 8px;
		color: #FFF;
	}
	.gb-photoalbum-header-album-list .gb-photoalbum-header-album-layout {
		padding: 0px 19px 0px 0px;
		height: 57px;
	}
	.gb-photoalbum-header-album-list .gb-photoalbum-header-album-layout .name {
		font-size: 13px;
		height: 1.3em;
		word-wrap: normal;
		overflow: hidden;
	}
	.gb-photoalbum-header-album-list .gb-photoalbum-header-album-layout .term {
		font-size: 10px;
	}
	.gb-photoalbum-header-album-list .gb-photoalbum-header-album-layout .schedule-title {
		font-size: 10px;
		word-wrap: normal;
		overflow: hidden;
		height: 1.3em;
	}
	.gb-photoalbum-header-album-list .btn-navigate-before {
		min-width: 24px;
		height: 59px;
	}
</style>
